import React, { useEffect, useState } from "react";
import { fetchUserDetails } from "../api";
import {
  Paper,
  Button,
  Tooltip,
  Box,
  Breadcrumbs,
  Link,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import UserProfileCard from "./UserProfileCard";
import LanguageGameplay from "./LanguageGameplay"; // ← import here

const cardPurple = "#7209d4";
const cardPurpleDisabled = "#d4b8ee";

const LANGUAGES = [
  { key: "hindi", label: "हिन्दी", present: true },
  { key: "english", label: "English", present: true },
  { key: "gujarati", label: "ગુજરાતી", present: true },
  { key: "marathi", label: "मराठी", present: false },
  { key: "telugu", label: "తెలుగు", present: false },
  { key: "odia", label: "ଓଡ଼ିଆ", present: false },
];

const UserDetails = ({ userId, onBack }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  useEffect(() => {
    setLoading(true);
    setUser(null);
    setSelectedLanguage(null); // Reset language when user changes
    fetchUserDetails(userId).then((data) => {
      if (data.success) setUser(data.userDetails);
      setLoading(false);
    });
  }, [userId]);

  if (loading)
    return (
      <div
        style={{
          marginTop: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </div>
    );

  return (
    <Box>
      <Breadcrumbs
        separator="/"
        aria-label="breadcrumb"
        sx={{ mb: 2, fontSize: 20, mt: 2 }}
      >
        <Link
          underline="hover"
          color="#7209D4"
          onClick={onBack}
          sx={{ cursor: "pointer", fontWeight: 600, fontSize: 16 }}
        >
          Users list
        </Link>
        <Typography color="text.primary" sx={{ fontWeight: 500, fontSize: 16 }}>
          User Details
        </Typography>
      </Breadcrumbs>
      <Paper style={{ padding: 16 }}>
        <div
          style={{
            display: "flex",
            gap: "60px",
            marginBottom: 16,
            alignItems: "center",
            justifyContent: "space-between",
            height: "210px",
          }}
        >
          {/* Left: User profile */}
          <div
            style={{
              flex: "1 1 350px",
              minWidth: 300,
              maxWidth: 520,
            }}
          >
            <UserProfileCard user={user} />
          </div>
          {/* Right: Languages */}
          <div
            style={{
              flex: "1 1 350px",
              minWidth: 300,
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "2rem",
              }}
            >
              {LANGUAGES.map((lang) =>
                lang.present ? (
                  <Button
                    key={lang.key}
                    onClick={() => setSelectedLanguage(lang.key)}
                    style={{
                      minWidth: 150,
                      minHeight: 70,
                      background: cardPurple,
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 24,
                      borderRadius: 12,
                      textTransform: "none",
                      boxShadow: "none",
                      letterSpacing: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                      opacity: 1,
                      cursor: "pointer",
                    }}
                    disableElevation
                    disableRipple
                  >
                    {lang.label}
                  </Button>
                ) : (
                  <Tooltip
                    key={lang.key}
                    title="Coming soon!"
                    arrow
                    placement="top"
                  >
                    <span>
                      <Button
                        disabled
                        style={{
                          minWidth: 150,
                          minHeight: 70,
                          background: cardPurpleDisabled,
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: 26,
                          borderRadius: 12,
                          textTransform: "none",
                          boxShadow: "none",
                          letterSpacing: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                          opacity: 0.6,
                          cursor: "not-allowed",
                        }}
                        disableElevation
                        disableRipple
                      >
                        {lang.label}
                      </Button>
                    </span>
                  </Tooltip>
                )
              )}
            </div>
          </div>
        </div>
        {/* Show LanguageGameplay below if a language is selected */}
        {selectedLanguage && (
          <LanguageGameplay userId={userId} language={selectedLanguage} />
        )}
      </Paper>
    </Box>
  );
};

export default UserDetails;
